import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const migrationInProgress = {
	migrationText: 'Omlouváme se, právě probíhají úpravy na naší aplikaci. Zkuste to prosím později.',
};

export default Object.assign({}, migrationInProgress, createLabeledMessages(migrationInProgress));
